import {
  CONTENT_POINT_QUESTION_TYPE_KNOWLEDGE,
  CONTENT_POINT_QUESTION_TYPE_SKILLS,
  CONTENT_POINT_QUESTION_TYPE_UNDERSTANDING,
  CER_TYPE_CLAIM,
  CER_TYPE_EVIDENCE,
  CER_TYPE_REASONING,
  ContentPointQuestionType,
  CerType,
} from 'global/constants';
import { FormData } from 'approot/shared/outcomes/outcome.constants';
import type { GetLessonTeachingAndLearningSequenceQuery } from '../teaching-notes.graphql.generated';
import type { Pluck } from 'lib/gql/pluck';

export type ActivityOutcomes = Pluck<
  GetLessonTeachingAndLearningSequenceQuery,
  'getLessonTeachingAndLearningSequence.activityOutcomes'
>;
export type ActivityOutcomeGroup = Pluck<
  GetLessonTeachingAndLearningSequenceQuery,
  'getLessonTeachingAndLearningSequence.activityOutcomes.outcomes'
>;

export const QUESTION_TYPES = [
  {
    label: 'Knowledge',
    value: CONTENT_POINT_QUESTION_TYPE_KNOWLEDGE as ContentPointQuestionType,
  },
  {
    label: 'Skills',
    value: CONTENT_POINT_QUESTION_TYPE_SKILLS as ContentPointQuestionType,
  },
  {
    label: 'Understanding',
    value:
      CONTENT_POINT_QUESTION_TYPE_UNDERSTANDING as ContentPointQuestionType,
  },
];

export const CER_TYPE_OPTIONS = [
  { label: 'Claim', value: CER_TYPE_CLAIM as CerType },
  { label: 'Evidence', value: CER_TYPE_EVIDENCE as CerType },
  { label: 'Reasoning', value: CER_TYPE_REASONING as CerType },
];

/**
 * A single Performance Expectation block: its outcome selections plus the
 * block-level Question Types and CER values, which persist on the PE outcome row.
 */
export type PerformanceExpectationGroup = {
  outcomes: FormData;
  questionTypes: ContentPointQuestionType[];
  cerTypes: CerType[];
};
